export const quarryDetailsLabels = {
  quarryType: "Quarry Type",
  quarryName: "Quarry Name",
  contactName: "Contact Name",
  phone: "Phone Number",
  address: "Location",
  coordinates: "Co-ordinates",
  accountLimit: "Account Charge Limit",
  accountTerms: "Account Terms",
};

export const FILTER_MARKER_KEY = "filter-marker";
